module.exports = __webpack_public_path__ + "img/meter-error.b22ef1c1.svg";